
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/personal_data_politics",
      function () {
        return require("private-next-pages/docs/personal_data_politics.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/personal_data_politics"])
      });
    }
  